import './Headers.less';
import TBIcon from '../compoment/Icon';
import { Menu, message, TreeSelect, Badge, Tabs } from 'antd';
//import { DownOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import Cookies from 'js-cookie';
import { loginOutContor } from '../utils/index';
import { BellOutlined } from '@ant-design/icons';
import { login } from '../utils/servers';
import { listDataDic, pageMessageCenter, signAsReadStatus, totalQuery } from '../utils/message';

import messNull from '../assets/image/message/messNull.png';
import messText from '../assets/image/message/messText.svg';
import Robot from '../assets/image/Robot.webm';
import { useState, useEffect } from 'react';
import Feedback from './Feedback/Feedback';
import DownCenter from './DownCenter/downCenter';
// import KnowledgeBase from './knowledgeBase';
function Headers(props) {
	useEffect(() => {
		getTotal();
		tabsClick(null);
		//getMessList();
	}, []);
	//获取默认登录id

	useEffect(() => {
		judgeAiIconVisible();
	});

	const [expandedKeys, setExpandedKeys] = useState(['']);
	const [isHovered, setIsHovered] = useState(false);
	const [totalData, setTotalData] = useState({
		totalBizMessages: 0,
		totalMessages: 0,
		totalNoticeMessages: 0,
		totalPolicyMessages: 0,
		totalTaskMessages: 0,
		totalUnRead: 0
	});
	// const [aiIconVisible, setAiIconVisible] = useState(false);
	const [messList, setMessList] = useState([]);
	// const [total, setTotal] = useState(0);
	const [messContent, setMessContent] = useState([]);
	const [open, setOpen] = useState(false);
	const [activeKey, setActiveKey] = useState();

	// 显示隐藏消息提示框
	const [showMess, setShowMess] = useState(false);
	const { userInfo, userOrgs, sysMenus, headerParentIds } = props;
	const { saveLoginInfo, saveMenus, addMenusHistory, saveSySMenus, addParentId, addHeaderParentIds, addCurrenmenu } =
		props;
	const confirm = () => {
		saveLoginInfo({});
		addMenusHistory([]);
		localStorage.setItem('userInfo', null);
		localStorage.setItem('myWorkplat', '[]');
		saveMenus([]);
		saveSySMenus([]);
		addHeaderParentIds('');
		loginOutContor();
		// 环境变量置空
		localStorage.setItem('env', '');
	};
	const orgId = userInfo.currentOrgId;
	const getMessList = async () => {
		const response = await getListDataDic('1155');
		setMessList([{ value: '1', label: '所有' }].concat(response));
		//setMessList(response);
	};
	const handleMouseEnter = () => {
		setIsHovered(true);
	};

	const handleMouseLeave = () => {
		setIsHovered(false);
	};

	const getTotal = () => {
		totalQuery().then((res) => {
			if (res.code === '200') {
				setTotalData(res.data || []);
			}
		});
	};
	async function getListDataDic(code) {
		if (!code) return [];
		let data = [];
		await listDataDic({ dicCategoryCode: code }).then((res) => {
			data = (res.data || []).map((item) => {
				item.label = item.dicName;
				item.value = item.dicCode;
				return item;
			});
		});
		return data;
	}

	function judgeAiIconVisible() {
		// setAiIconVisible(true);
		// let isProd = process.env.REACT_APP_ENVVAR === 'production';
		// if (isProd) {
		// 	if (orgId === '144715358218731564') {
		// 		setAiIconVisible(true);
		// 	} else {
		// 		setAiIconVisible(false);
		// 	}
		// } else {
		// 	setAiIconVisible(false);
		// }
	}

	//定义图标
	const MessageBell = (props) => (
		<span
			className="smallBell"
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
			onClick={() => openMess()}>
			<Badge className='messageCount' count={totalData.totalUnRead}>
				<BellOutlined className="hoverBell" />
			</Badge>
			{isHovered && <span className="smallBell_xx">消息</span>}
		</span>
	);
	//意见反馈
	const FeedbackComp = (props) => (
		<span>
			<Feedback></Feedback>
		</span>
	);
	const DownCenterComp = (props) => (
		<span>
			<DownCenter></DownCenter>
		</span>
	);
	const closeMess = () => {
		setShowMess(false);
	};
	// 点击单条信息
	const seeMessItem = (data) => {
		// console.log('查看明细信息');
		// let ids = [data];
		// signAsRead(ids);
	};
	const openMess = () => {
		console.log('点开了消息数据');
		getMessList();
		setShowMess(true);
	};
	// 全部已读信息
	const seeAll = () => {
		let ids = messContent.map((item) => {
			return item.imId;
		});

		signAsRead(ids);
		setShowMess(false);
	};
	// 全部已读数据
	const signAsRead = (idList) => {
		signAsReadStatus({ idList }).then((res) => {
			if (res.code === '200') {
				tabsClick(null);
				getTotal();
				message.success('操作成功');
			}
		});
	};
	//进行展开
	const onTreeExpand = (orgId) => {
		//console.log(orgId);
		let flag = expandedKeys.findIndex((item) => {
			return item === orgId;
		});
		if (flag !== -1) {
			setExpandedKeys([expandedKeys.splice(flag, 1)]);
		} else {
			setExpandedKeys([orgId]);
		}
  };
  
  let aiWindow = null;

  const turnOnTheAiAgent = () => {
    const url = `${process.env.REACT_APP_REGISTEREDAUDIT_URL}/registered-audit-manager/aiPlatform`;
  
    if (aiWindow && !aiWindow.closed) {
      // 已存在 → 直接聚焦
      aiWindow.focus();
    } else {
      // 不存在 → 打开新窗口
      aiWindow = window.open(url, 'AI_AGENT_WINDOW');
    }
  };
  
	const showtotal = function (code) {
		let returnTotal = {
			1155005: 'totalNoticeMessages',
			1155010: 'totalTaskMessages',
			1155015: 'totalPolicyMessages',
			1155020: 'totalBizMessages'
		};

		return totalData[returnTotal[code] || 'totalMessages']; //  设置code对应总数关系
	};
	// 查看全部
	const seeAlldata = () => {
		window.location.href = `${process.env.REACT_APP_SSO_URL}/zeus-system/system-permissions/messageCenter`;
		setShowMess(false);
	};
	// 消息点击请求事件  只查询已读信息
	const tabsClick = (e) => {
		console.log(e);
		setActiveKey(e || '1');
		let query = {
			condition: {
				messageClassCode: e === 1 ? '' : e,
				readStatus: 'UNREAD'
			},
			pageNum: 1,
			pageSize: 20
		};
		pageMessageCenter(query).then((res) => {
			setMessContent(res.data.records || []);
			//setTotal(res.data.total);
		});
	};
	//选择公司事件
	const changeRole = (orgId) => {
		// 选择的是端 所以不进行跳转
		if (orgId === '1002005' || orgId === '1002010' || orgId === '1002015' || orgId === '1002020') {
			onTreeExpand(orgId);
			return;
		}
		let orgTypeCode = '';
		for (var item of userOrgs) {
			if (item.orgInfoList && item.orgInfoList.length > 0) {
				let tempData = item.orgInfoList.find((data) => {
					return data.orgId === orgId;
				});
				if (tempData) {
					orgTypeCode = item.orgTypeCode;
					break;
				}
			}
		}
		// 进行登录接口请求 来进行设置数据
		login({ orgId, phone: userInfo.phone, orgTypeCode }).then((data) => {
			if (data.code === '200') {
				// 判断是否存在预发环境变量，如果存在将env=pre预先存一下，清除缓存后再塞进缓存；
				let envVar = localStorage.getItem('env');
				localStorage.clear();
				if (envVar) {
					localStorage.setItem('env', envVar);
				}
				Cookies.set('token', data.data.accessToken);
				localStorage.setItem('loginInfo', JSON.stringify(data.data));
				addMenusHistory([]);
				addParentId([]);
				addHeaderParentIds('');
				addCurrenmenu('');
				window.location.href = process.env.REACT_APP_SSO_URL;
			} else {
				message.error(data.msg || '切换公司失败');
			}
		});
	};

	const sysMenu = sysMenus.map((item) => {
		let { id, asName } = item;
		return <Menu.Item key={id}>{asName}</Menu.Item>;
	});
	return (
		<div className="Headers">
			{/* <h2>嗨，欢迎使用蜂巢灵工！</h2> */}
			<div className="leftPart">
				<div className="sildebar-logo">
					<TBIcon style={{ height: '64px', width: '120px' }} type="fclg-logo" />
					<span style={{ height: '18px', margin: '0 5px', borderRight: '1px solid white' }}></span>
					<div className="platType">{userInfo.plateformName}</div>
				</div>
				<Menu
					className="headerMenus"
					style={{ width: 'calc(100vw - 800px)', height: '64px' }}
					theme="dark"
					mode="horizontal"
					onSelect={props.headerSelect}
					defaultSelectedKeys={[headerParentIds || sysMenus[0]?.id]}>
					{sysMenu}
				</Menu>
			</div>
			<div className="orgCmp">
				<div className="aiIcon" onClick={turnOnTheAiAgent}>
					<div className='aiIconImg'> 
						<video autoPlay loop muted playsInline style={{ width: 32, height: 32 }}>
							<source src={Robot} type="video/webm" />
						</video>
					</div>
					<div className="aiIconText">小桐AI</div>
				</div>

				{/* {aiIconVisible && <KnowledgeBase></KnowledgeBase>} */}
				<div className="flexHeader">
					<DownCenterComp></DownCenterComp>
					<FeedbackComp></FeedbackComp>
					<MessageBell></MessageBell>
				</div>
				{/* 用showMess控制显示隐藏 消息弹框的 */}
				{showMess === true ? (
					<Tabs
						activeKey={activeKey}
						defaultActiveKey="null"
						onChange={(value) => tabsClick(value)}
						className="messageDetail"
						mouseout={() => openMess()}
						onMouseLeave={() => closeMess()}>
						{messList.map((item, indxe) => {
							return (
								<Tabs.TabPane tab={item.label + '（' + showtotal(item.value) + '）'} key={item.value}>
									{/* <div>{item.msgContent}</div> */}
									<div className={messContent.length > 0 ? 'messageitemS' : 'hide'}>
										{messContent.map((data, index) => {
											return (
												<div className="messItem" onClick={() => seeMessItem(data.imId)}>
													<img className="messItem-img" src={messText} alt=""></img>
													<div className="messIte-Data">
														<div>{data.title}</div>
														<div className="messItem-title">{data.messageContent}</div>
														<div className="messIt_createTime">{data.createTime}</div>
													</div>
												</div>
											);
										})}
									</div>
									<div className={messContent.length < 1 ? 'messageImg' : 'hide'}>
										<img alt="logo" src={messNull} style={{ width: '136px' }} {...props} />
									</div>
									<div className="messOperation">
										<div className="messOperation-edit">
											<span className="messOperation-unread">
												未读{totalData.totalUnRead ? '（' + totalData.totalUnRead + '）' : ''}
											</span>

											{/* <Popconfirm title="您确定阅读全部吗?" onConfirm={seeAll} okText="是" cancelText="否"> */}
											<span onClick={seeAll}>全部已读</span>
											{/* </Popconfirm> */}
										</div>
										<div className="messOperation-see" onClick={seeAlldata}>
											查看全部
											<span>&gt;</span>
										</div>
									</div>
								</Tabs.TabPane>
							);
						})}
					</Tabs>
				) : null}
				<TreeSelect
					treeData={userOrgs}
					bordered={false}
					style={{
						color: 'white',
						fontSize: '14px'
					}}
					className="treeSelect"
					open={open}
					onFocus={() => setOpen(true)}
					onBlur={() => setOpen(false)}
					onTreeExpand={(data) => {
						setExpandedKeys([...(data || [])]);
					}}
					treeDefaultExpandAll
					onChange={(value) => changeRole(value)}
					dropdownMatchSelectWidth={false}
					defaultValue={userInfo.currentOrgId}
					key={userOrgs.currentOrgId}
					value={orgId}
					fieldNames={{ label: 'displayOrgName', value: 'orgId', children: 'orgInfoList' }}></TreeSelect>
				<span className="loginOut" onClick={confirm}>
					退出
				</span>
			</div>
		</div>
	);
}
const mapStateToProps = (state) => {
	return {
		userInfo: state.userInfo,
		userOrgs: state.userOrgs,
		menus: state.menus,
		sysMenus: state.sysMenus,
		parentIds: state.parentIds,
		headerParentIds: state.headerParentIds
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		saveLoginInfo: (info) => dispatch({ type: 'ADD_LOGININFO', info }),
		saveMenus: (info) => dispatch({ type: 'ADD_MENUS', info }),
		addMenusHistory: (info) => dispatch({ type: 'ADD_MENUSHISTORY', info }),
		saveSySMenus: (info) => dispatch({ type: 'ADD_SYSMENUS', info }),
		addParentId: (info) => dispatch({ type: 'ADD_PARENTID', info }),
		addHeaderParentIds: (info) => dispatch({ type: 'ADD_HEADERPARENTID', info }),
		addCurrenmenu: (info) => dispatch({ type: 'ADD_CURRENMENU', info })
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(Headers);
